<template>
    <div class="exchange">
        <div class="exchange_head">
            <button @click="$router.go(-1)">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18.5L9 12.5L15 6.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <h2>{{text('exchange.index.title')}}</h2>
        </div>
        <div class="exchange_block">
            <template v-if="!exchangeFromAccount || !exchangeToAccount">
                <p>{{text('exchange.index.not_available')}}</p>
            </template>
            <template v-if="exchangeFromAccount && exchangeToAccount">
            <div class="exchange_card">

                <div class="exchange_card__top">
                    <h4>{{text('exchange.from')}}</h4>
                    <p>
                        {{text('exchange.current_balance')}}
                        <span>{{exchangeFromAccount.balance}}</span>
                        <span @click="setMax" class="text-green">MAX</span>
                    </p>
                </div>
                <div class="exchange_card__bottom">
                    <button @click="selectExchangeOpenedFrom">
                        <span>{{exchangeFromAccount.currency_code}}</span>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.30078 4.16602L12.181 8.78943C12.875 9.44681 12.875 10.5519 12.1811 11.2093L7.30078 15.8327" stroke="#A6A4B4" stroke-width="1.25" stroke-linecap="round"/>
                        </svg>
                    </button>
                    <div class="money-inp__wrap">                    
                        <input
                            v-model="fromAmount"
                            @input="updateFromAmount"
                            data-maska="9 99#.##"
                            class="money-inp"
                        >
                        <span>{{getCurrencySymbol(exchangeFromAccount.currency_code)}}</span>
                    </div>
                </div>                
            </div>
            <button @click="changeExchangeAccounts" class="change_btn">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.93 16.6663V3.33301M14.93 3.33301L18.7507 7.15367M14.93 3.33301L11.1094 7.15367" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.90465 3.33268V16.666M5.90465 16.666L9.72531 12.8454M5.90465 16.666L2.08398 12.8454" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <div class="exchange_card">
                <div class="exchange_card__top">
                    <h4>{{text('exchange.to')}}</h4>
                    <p>
                        {{text('exchange.current_balance')}}
                        <span>{{exchangeToAccount.balance}}</span>
                    </p>
                </div>
                <div class="exchange_card__bottom">
                    <button @click="selectExchangeOpenedTo">
                        <span>{{exchangeToAccount.currency_code}}</span>                        
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.30078 4.16602L12.181 8.78943C12.875 9.44681 12.875 10.5519 12.1811 11.2093L7.30078 15.8327" stroke="#A6A4B4" stroke-width="1.25" stroke-linecap="round"/>
                        </svg>
                    </button>
                    <div class="money-inp__wrap">
                        <input
                            v-model="toAmount"
                            @input="updateToAmount"
                            data-maska="9 99#.##"
                            class="money-inp"
                        >
                        <span>{{getCurrencySymbol(exchangeToAccount.currency_code)}}</span>
                    </div>
                </div>
                <div class="line"></div>
                <div class="exchange_card__foot">
                    {{ getExchangeRateString(exchangeFromAccount.currency_code, exchangeToAccount.currency_code) || text('exchange.index.no_rate') }}
                </div>
            </div>
        </template>
        </div>

        <div class="error">{{ errorMessage }}</div>


        <Button 
            v-if="exchangeFromAccount && exchangeToAccount"
            :disabled="!getExchangeRateString(exchangeFromAccount.currency_code, exchangeToAccount.currency_code)
                || isNaN(fromAmount) || isNaN(toAmount) 
                || fromAmount == '0' || toAmount == '0' 
                || fromAmount == '' || toAmount == ''
                || parseFloat(fromAmount) > exchangeFromAccount.balance
            "        
            @click="doExchange"
            :title="text('exchange.index.submit_btn')"
        />


        <GrokPolicy v-if="envName === 'grok'" />

        <!-- @click="$router.push({name: 'ExchangeConfirm'})"  -->
    </div>
</template>

<script>
import Button from '@/components/Button.vue'
import MoneyInput from '@/components/MoneyInput.vue'
import GrokPolicy from '@/components/GrokPolicy.vue'

export default {
    name: "Exchange",
    components: {
        Button,
        MoneyInput,
        GrokPolicy,
    },
    created() {     
        this.$store.dispatch('setDefaultExchangeAccounts')        
        this.$store.dispatch('refreshExchangeRates')
    },
    computed: {
        exchangeFromAccount () {
            return this.$store.state.exchangeFromAccount
        },
        exchangeToAccount () {
            return this.$store.state.exchangeToAccount
        },
        walletList () {
            return this.$store.state.walletList
        },
        exchangeRates () {
            return this.$store.state.exchangeRates
        },
    },
    data () {
        return {
            errorMessage: '',
            fromAmount: '0',
            toAmount: '0',
        }
    },
    methods: {
        selectExchangeOpenedFrom() {
            //this.$store.commit('changeSelectExchange', true);
            //this.$store.commit('selectExchangeActiveTab', 'from');
        },
        selectExchangeOpenedTo() {
            //this.$store.commit('changeSelectExchange', true);
            //this.$store.commit('selectExchangeActiveTab', 'to');
        },
        changeExchangeAccounts() {
            const tmpAmount = this.fromAmount;
            this.fromAmount = this.toAmount;
            this.toAmount = tmpAmount;            

            const tmpAccount = this.exchangeFromAccount;
            this.$store.commit("updateExchangeFromAccount", this.exchangeToAccount);  
            this.$store.commit("updateExchangeToAccount", tmpAccount); 
        },
        setMax () {
            this.fromAmount = this.exchangeFromAccount.balance
            this.updateFromAmount()
        },
        getExchangeRateString (from, to) {
            if (!this.exchangeRates.rates) {
                return ''
            }

            const rate = this.exchangeRates.rates.find(rate => rate.from_currency_code === from && rate.to_currency_code === to)
            
            if (!rate) {
                return ''
            }

            return `${rate.quantity_in} ${rate.from_currency_code} = ${rate.quantity_out} ${rate.to_currency_code}`;
        },
        getExchangeRate (from, to) {
            const rate = this.exchangeRates.rates.find(rate => rate.from_currency_code === from && rate.to_currency_code === to)

            if (parseFloat(rate.quantity_in) != 1) {
                return NaN
            } else {
                return rate.quantity_out
            }
        },        
        updateFromAmount() {
            const rate = this.getExchangeRate(this.exchangeFromAccount.currency_code, this.exchangeToAccount.currency_code);
            this.toAmount = Math.round(rate * parseFloat(this.fromAmount) * 100) / 100;
        },            
        updateToAmount() {
            const rate = this.getExchangeRate(this.exchangeFromAccount.currency_code, this.exchangeToAccount.currency_code);
            this.fromAmount = Math.round((parseFloat(this.toAmount) / rate) * 100) / 100;
        },        
        async doExchange() {
            // TODO сохранять
            const rate = this.exchangeRates.rates.find(rate =>
                rate.from_currency_code === this.exchangeFromAccount.currency_code &&
                rate.to_currency_code === this.exchangeToAccount.currency_code
            )

            const response = await this.$store.dispatch("doExchange", {
                from_account_id: this.exchangeFromAccount.id,
                to_account_id: this.exchangeToAccount.id,
                from_amount: this.fromAmount.toString(),
                to_amount: this.toAmount.toString(),
                rate_id: rate.id,
            })

            if (response.status === 'error') {
                this.errorMessage = response.message
            } else {
                alert(this.text('exchange.index.success_message'))
                this.$router.push({name: 'Home'})
            }            
        }
    }
}
</script>

<style>

</style>